<mat-form-field appearance="outline" class="filter-input">
  <mat-label>{{ label }}</mat-label>
  <input type="text"
         matInput [matAutocomplete]="auto"
         [formControl]="filterCtrl"
         [placeholder]="placeholder"
         autocomplete="off"
         (keyup)="onSearchChanged($event)" />

  @if (!filterCtrl.value) {
    <button mat-icon-button matSuffix aria-label="search text">
      <mat-icon role="img" aria-label="search">{{ 'autocomplete.search' | translate }}</mat-icon>
    </button>
  }
  @else {
    <button mat-icon-button matSuffix aria-label="Clear text" (click)="clearSearch()">
      <mat-icon role="img" aria-label="close">{{ 'autocomplete.close' | translate }}</mat-icon>
    </button>
  }

  <mat-autocomplete #auto="matAutocomplete" class="autocomplete-panel" (optionSelected)="onOptionSelected($event.option.value)">
    @let elements = filteredList$ | async;
    @if (elements !== null) {
      @if (isLoading) {
        <mat-option disabled>
          <div class="flex items-center gap-2">
            <mat-progress-spinner mode="indeterminate" diameter="20" color="primary"></mat-progress-spinner>
            <span>{{ 'autocomplete.loading' | translate }}</span>
          </div>
        </mat-option>
      }
      @else if (error) {
        <mat-option disabled>
          <span class="text-red-500">{{ error | translate }}</span>
        </mat-option>
      }
      @else if (!isLoading && !error && elements.length === 0) {
        <mat-option disabled>
          <span class="text-gray-500">{{ 'autocomplete.noResults' | translate }}</span>
        </mat-option>
      }
      @else if (!isLoading && !error && elements.length > 0) {
        <mat-option *ngFor="let element of elements" [value]="element">
          @if (displayKey !== '') {
            {{ element[displayKey] }}
          } @else {
            {{ element }}
          }
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
